import { create as ipfsHttpClient } from "ipfs-http-client";
import { getSecrets } from "../config";
import { NFTIcon } from "../images";
import { ProticoClient } from "protico-sdk";
import api, { getProticoClient, API_POST_AVATAR_UPLOAD_START } from "./api";
const { INFURA_PROJECT_ID, INFURA_PROJECT_SECRET, BACKEND_URL } = getSecrets();
const client = ipfsHttpClient({
  host: "ipfs.infura.io",
  port: 5001,
  protocol: "https",
  headers: {
    authorization:
      "Basic " + btoa(INFURA_PROJECT_ID + ":" + INFURA_PROJECT_SECRET),
  },
});
export const uploadFile = async (file: File) => {
  // replace the ipfs code with the following code
  // try {
  //   const added = await client.add(file, {
  //     progress: (prog) => console.log(`received: ${prog}`),
  //   });
  //   return added.path;
  // } catch (error) {
  //   throw new Error(`${error}`);
  // }
  try {
    let response = await getProticoClient().api.post(
      API_POST_AVATAR_UPLOAD_START,
      {
        file_name: file.name,
        file_type: file.type,
      }
    );

    const postData = new FormData();

    for (const key in response.data?.fields) {
      postData.append(key, response.data.fields[key]);
    }

    postData.append("file", file);

    let postParams = {};

    // If we're uploading to S3, detach the authorization cookie.
    // Otherwise, we'll get CORS error from S3
    if (response.data?.fields) {
      postParams = {};
    }

    await api
      .post(response.data.url, postData, postParams)
      .then(() => Promise.resolve({ fileId: response.data.id }));
    return response.data.id;
  } catch (error) {
    throw new Error(`${error}`);
  }
};

export const getInfuraUrl = (url: string) =>
  "https://protico.infura-ipfs.io/ipfs/" + url;

export const getAmazonS3Url = (url: string) =>
  "https://d2p81v1aubrdvf.cloudfront.net/avatars/" + encodeURIComponent(url);

export const getImageAssetUrl = (url: string) =>
  "https://assets.protico.io/avatars/" + encodeURIComponent(url);

export const fixOldInfuraUrl = (url?: string) => {
  if (!url) return undefined;
  url = url.replace("ipfs.infura.io", "protico.infura-ipfs.io");
  if (url?.substring(0, 7) == "ipfs://") {
    return "https://alchemy.mypinata.cloud/ipfs/" + url.substring(7);
  } else if (
    url?.substring(0, 30) == "https://protico.infura-ipfs.io" ||
    url?.substring(0, 18) == "https://i.seadn.io" ||
    url?.substring(0, 35) == "https://alchemy.mypinata.cloud/ipfs" ||
    url?.substring(0, 36) == "https://assets.protico.io/ai_avatars" ||
    url?.substring(0, 33) == "https://assets.protico.io/avatars" ||
    url?.substring(0, 44) == "https://assets.protico.io/generation/avatars" // ai avatar v2
  ) {
    return url;
  } else {
    return NFTIcon;
  }
};
